import React, { useCallback, useEffect } from "react"

import Container from "@ecom/ui/components/Container"
import { useLocation } from "@gatsbyjs/reach-router"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { PersonalForm } from "../../FormPKW/Form/PersonalForm"
import disableWebvisor from "../../../utils/disableWebvisor"
import * as styles from "./form.module.scss"
import { IFormPKW } from "./types"
import { Timer } from "./Timer/Timer"
import { handleClickForm } from "../../../helpers/WatcherDL/utils/handleClickForm"

const defaultSubTitle = <>Быстрая&nbsp;и&nbsp;бесплатная доставка или&nbsp;самовывоз</>

export function Form({
  headTitle = "Оформите карту",
  headDescr = defaultSubTitle,
  isGreenApprove = false,
  dataLayerName,
  formBtnText,
  orderNum,
  withTimer = false,
  fioPlaceHolder = "Фамилия Имя Отчество",
  choiceProduct = false,
  setProductName,
  productName,
  hasSelect = false,
  hasCityWithOffices = false,
  thanksPage,
  progressBar = false,
  selectItems,
  selectTitle,
  inputsColor,
  countDownTime,
  variant,
}: IFormPKW) {
  const location = useLocation()
  const isDesktop = useMediaQuery("(min-width:960px)")

  // отключение записи ПД в вебвизоре
  const ref = useCallback((node: any) => {
    disableWebvisor(node)
  }, [])

  useEffect(() => {
    const handleScrollToForm = () => {
      const element = document.getElementById("app")
      if (element) {
        const offset = 120
        const position = window?.scrollY - offset
        window?.scrollTo({ top: position })
      }
    }
    if (isDesktop && location?.hash === "#app") {
      handleScrollToForm()
    }
  }, [isDesktop, location])

  return (
    <section className={styles.section} data-exclude={orderNum} id="formPkw">
      <div className={styles.anchor} id="app" />
      <div className={styles.wrapperForm}>
        <Container>
          <div className={styles.innerWrapperForm}>
            <div className={styles.textBlock}>
              <h2 className={styles.headTitle} ref={ref}>
                {headTitle}
              </h2>
              <p className={styles.headDescr}>{headDescr}</p>
            </div>

            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div onClick={handleClickForm} onKeyDown={handleClickForm}>
              <PersonalForm
                variant={variant}
                hasCityWithOffices={hasCityWithOffices}
                progressBar={progressBar}
                choiceProduct={choiceProduct}
                setProductName={setProductName}
                dataLayerName={dataLayerName}
                formBtnText={formBtnText}
                productName={productName}
                isGreenApprove={isGreenApprove}
                fioPlaceHolder={fioPlaceHolder}
                hasSelect={hasSelect}
                thanksPage={thanksPage}
                selectItems={selectItems}
                selectTitle={selectTitle}
                inputsColor={inputsColor}
              />
            </div>
          </div>
        </Container>
      </div>

      {withTimer && <Timer countDownTime={countDownTime} />}
    </section>
  )
}
